export default __webpack_public_path__ + "static/media/PAULAS CHOICE INTERVIEW_FINWEB5.2c89aa0b.png";